export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["numero"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancellare"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salva"])}
}